import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useObjectHistoryFilterWidget } from '../../../hooks/useObjectHistoryFilterWidget';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useObjectHistoryStoreFilterWidgetWidget = () => {
    const [historyStoreFilter, setObjectHistoryFilter] = useState({});
    const { filterWidgetComponents } = useObjectHistoryFilterWidget({
        historyStoreKey: 'recentStateHistory',
        objectHistoryFilter: historyStoreFilter,
        setObjectHistoryFilter: (filterRequest) => setObjectHistoryFilter(filterRequest),
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "period" }), _jsx(Stack, { direction: "row", children: filterWidgetComponents.period }), _jsx(Typography, { variant: "h5", children: "readings" }), _jsx(Stack, { direction: "row", children: filterWidgetComponents.readings }), _jsx(Typography, { variant: "h5", children: "sample" }), _jsx(Stack, { direction: "row", children: filterWidgetComponents.sample })] })), [filterWidgetComponents]);
    return {
        name: 'useObjectHistoryFilterWidget',
        category: 'hooks',
        component,
    };
};
